/**
 * Copy icon for payment link copy button.
 * Color: Blue (#06A4F3)
 */
export const CopyIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <rect
      x="7"
      y="7"
      width="10"
      height="10"
      rx="2"
      stroke="#06A4F3"
      strokeWidth="1.5"
      fill="none"
    />
    <path
      d="M13 7V5C13 3.89543 12.1046 3 11 3H5C3.89543 3 3 3.89543 3 5V11C3 12.1046 3.89543 13 5 13H7"
      stroke="#06A4F3"
      strokeWidth="1.5"
    />
  </svg>
);
